import { render, staticRenderFns } from "./QuestionView.vue?vue&type=template&id=09381b7e&scoped=true"
import script from "./QuestionView.vue?vue&type=script&lang=js"
export * from "./QuestionView.vue?vue&type=script&lang=js"
import style0 from "./QuestionView.vue?vue&type=style&index=0&id=09381b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09381b7e",
  null
  
)

export default component.exports